module.exports = __webpack_public_path__ + "assets/img/step8-3-sz.0dc3aa5f.png";